/* KBW Style Header — the gallery.

   One job: moving between the style's pictures. Everything on the page is
   printed server-side, so with scripting off the customer still sees the first
   image, its caption, the specs and the prices — they just cannot page through
   the shots.

   Markup contract:
     [data-kbw-sh]          section root
     [data-kbw-sh-gallery]  the gallery card
     [data-kbw-sh-stage]    the big image
     [data-kbw-sh-thumb]    one per thumbnail, carrying data-full and data-caption
     [data-kbw-sh-prev]     previous arrow, drawn only when there are 2+ images
     [data-kbw-sh-next]     next arrow
     [data-kbw-sh-caption]  the words in the caption strip
     [data-kbw-sh-index]    the left-hand number of the "1 / 3" counter

   The caption and the counter are printed for the FIRST image server-side and
   only ever rewritten here, so a script that fails to load leaves a caption
   that is correct rather than one that is empty.
*/

(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.kbwShReady === '1') return;

    var stage = root.querySelector('[data-kbw-sh-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-kbw-sh-thumb]'));
    if (!stage || thumbs.length < 2) return;

    root.dataset.kbwShReady = '1';

    var captionEl = root.querySelector('[data-kbw-sh-caption]');
    var indexEl = root.querySelector('[data-kbw-sh-index]');
    var prev = root.querySelector('[data-kbw-sh-prev]');
    var next = root.querySelector('[data-kbw-sh-next]');
    var current = 0;

    function show(i) {
      /* Wraps at both ends. A slider with a counter that says "3 / 3" has told
         the customer where the end is; refusing to move from it after that is
         a dead control, not a boundary. */
      var n = thumbs.length;
      i = ((i % n) + n) % n;

      var btn = thumbs[i];
      var full = btn.getAttribute('data-full');
      current = i;

      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
      if (captionEl) captionEl.textContent = btn.getAttribute('data-caption') || '';
      if (indexEl) indexEl.textContent = String(i + 1);

      if (!full || stage.getAttribute('src') === full) return;

      /* The stage holds a fixed square, so nothing moves while the new file
         arrives — but a half-drawn swap still reads as a glitch. Waiting for
         the decode keeps it to a single clean change. */
      var img = new Image();
      img.onload = function () {
        stage.src = full;
        /* The alt describes the style, not the individual shot, so it stays. */
      };
      img.src = full;
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { show(i); });
    });

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-sh]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();
